// TableauPersonne.jsx
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import ContactForm from './ContactForm';
import ConfirmationModal from '../../../Modal/ConfirmationModal';
import {
  getPersonContactsByAccount,
  deletePersonContact
} from '../../../service/api/personContactService';
import { useLoader } from '../../../service/Hooks/useLoader';

const TableauPersonne = ({ account = {}, accountId, domainId, onClose }) => {
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [editingContact, setEditingContact] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [contactToDelete, setContactToDelete] = useState(null);
  const { showLoader, hideLoader } = useLoader();
  

  const fetchContacts = async () => {
    try {
      const data = await getPersonContactsByAccount(accountId,domainId);
      setContacts(data);
    } catch (error) {
      toast.error('Erreur lors de la récupération des personnes à contacter');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (accountId) fetchContacts();
  }, [accountId]);

  const handleEdit = contact => {
    setEditingContact(contact);
    setShowForm(true);
  };

  const handleDeleteClick = contact => {
    setContactToDelete(contact);
    setShowConfirmationModal(true);
  };

  const confirmDelete = async () => {
    if (!contactToDelete) return;
    showLoader({ message: "Suppression en cours...", indeterminate: true });

    try {
      await deletePersonContact(contactToDelete.id);
      toast.success('Personne à contacter supprimée avec succès');
      fetchContacts();
    } catch (error) {
      toast.error('Erreur lors de la suppression de la personne à contacter');
    } finally {
      setShowConfirmationModal(false);
      setContactToDelete(null);
      hideLoader();
    }
  };

  const cancelDelete = () => {
    setShowConfirmationModal(false);
    setContactToDelete(null);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingContact(null);
  };

  const handleSuccessForm = () => {
    fetchContacts();
    handleCloseForm();
  };

  if (showForm) {
    return (
      <ContactForm
        account={account}
        accountId={accountId}
        editingContact={editingContact}
        onClose={handleCloseForm}
        onSuccess={handleSuccessForm}
      />
    );
  }

  return (
    <div className="modal modal fade show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog  modal-dialog-centered modal-custom">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
            Personnes à contacter pour{' '}
          <strong className="text-primary text-muted">{account.accountTypeName}</strong>{' '}
          <strong className="text-primary">
            {account.companyName || `${account.firstName} ${account.lastName}`}
          </strong>
            </h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {isLoading ? (
              <p>Chargement...</p>
            ) : (
            <div className="table-responsive">
                <table className="table table-striped align-middle">
                  <thead className="tables-light">
                    <tr>
                      <th>Prénom</th>
                      <th>Nom</th>
                      <th>Téléphone</th>
                      <th>Email</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contacts.length > 0 ? (
                      contacts.map(contact => (
                        <tr key={contact.id}>
                          <td>{contact.firstName}</td>
                          <td>{contact.lastName}</td>
                          <td>{contact.telephone}</td>
                          <td>{contact.email}</td>
                          <td className="text-center">
                            <button
                              className="btn btn-sm btn-primary me-2"
                              onClick={() => handleEdit(contact)}
                              data-tooltip-id={`edit-${contact.id}`}
                              data-tooltip-content="Modifier"
                            >
                              ✎
                              <Tooltip id={`edit-${contact.id}`} place="top" effect="solid" />
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDeleteClick(contact)}
                              data-tooltip-id={`delete-${contact.id}`}
                              data-tooltip-content="Supprimer"
                            >
                              🗑
                              <Tooltip id={`delete-${contact.id}`} place="top" effect="solid" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-muted">
                          Aucune personne à contacter trouvée pour ce compte.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          message={`Êtes-vous sûr de vouloir supprimer ${contactToDelete.firstName} ${contactToDelete.lastName} ? Cette action est irréversible.`}
          onConfirm={confirmDelete}
          onCancel={cancelDelete}
        />
      )}
    </div>
  );
};

export default TableauPersonne;
